export enum DonorCategoryThresholdEnum {
    REGULAR = 'regular',
    OCCASIONAL = 'occasional',
    REPEATED = 'repeated',
    ONETIME = 'onetime',
    NONE = 'none',
}

export const donorCategoryThresholdOptions = [
    { id: DonorCategoryThresholdEnum.REGULAR },
    { id: DonorCategoryThresholdEnum.OCCASIONAL },
    { id: DonorCategoryThresholdEnum.REPEATED },
    { id: DonorCategoryThresholdEnum.ONETIME },
    { id: DonorCategoryThresholdEnum.NONE },
];

export const donorCategoryThresholdTimeLimitQuery = {
    [DonorCategoryThresholdEnum.REGULAR]: "'1' year",
    [DonorCategoryThresholdEnum.OCCASIONAL]: "'1' year",
    [DonorCategoryThresholdEnum.REPEATED]: "'3' year",
    [DonorCategoryThresholdEnum.ONETIME]: "'3' year",
};

export const donorCategoryThresholdAmountLimitQuery = {
    [DonorCategoryThresholdEnum.REGULAR]: '>= 11',
    [DonorCategoryThresholdEnum.OCCASIONAL]: '> 1',
    [DonorCategoryThresholdEnum.REPEATED]: '> 1',
    [DonorCategoryThresholdEnum.ONETIME]: '>= 1',
};

export const defaultDonorCategoryThreshold = DonorCategoryThresholdEnum.ONETIME;
